// extracted by mini-css-extract-plugin
export default {"heading":"SSSContainer_heading__+m6Zx","accordionItem":"SSSContainer_accordionItem__b7hrP","accordionTextContainer":"SSSContainer_accordionTextContainer__KwEHV"};